import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_GRANSUR_TANGER_RAK } from "@/lib/itineraryHubs";
export default function GransurTangerRakHubPage() {
  return <ItineraryHubPage hub={HUB_GRANSUR_TANGER_RAK} />;
}
